// lib
import { getCleanUrl } from 'shared/helpers/utils/url';
import escape from 'lodash/escape';

// constants
import { IS_FILTERED_URL } from 'shared/layouts/Listing/Api/constants';

export const appendURLParameters = (url: string, param: string) => {
  const params = new URLSearchParams(param);
  const cleanUrl = getCleanUrl(url);

  if (cleanUrl.indexOf('?') > -1) {
    return `${cleanUrl}&${params.toString()}`;
  }

  return `${cleanUrl}?${params.toString()}`;
};

export const PINNED_PROD_IDS_SEARCHTERM = 'pinned_product_id';

export const getPinnedProdcutsFromSearch = (existingSearch = ''): string => {
  const searchParams = new URLSearchParams(existingSearch);

  if (searchParams.has(PINNED_PROD_IDS_SEARCHTERM)) {
    // @ts-ignore
    return escape(searchParams.get(PINNED_PROD_IDS_SEARCHTERM));
  }

  return '';
};

export const getIsFilteredUrl = (existingSearch = ''): boolean => {
  const searchParams = new URLSearchParams(existingSearch);

  if (searchParams.has(IS_FILTERED_URL)) {
    // @ts-ignore
    return Boolean(escape(searchParams.get(IS_FILTERED_URL)));
  }

  return false;
};
